export const CA_PROVINCES = [
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Northwest Territories",
  "Nova Scotia",
  "Nunavut",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Yukon",
];

export const COUNTRIES = [
  "Argentina", "Australia", "Austria", "Bahamas", "Bahrain", "Bangladesh", "Belgium", "Brazil",
  "Cameroon", "Canada", "Chile", "China", "Colombia", "Côte d'Ivoire", "Cuba", "Cyprus",
  "Czechia", "Denmark", "Egypt", "Eritrea", "Ethiopia", "Fiji", "Finland", "France",
  "Georgia", "Germany", "Ghana", "Greece", "Guyana", "Hong Kong", "Hungary", "Iceland",
  "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica",
  "Japan", "Jordan", "Kenya", "Kuwait", "Lebanon", "Malaysia", "Maldives", "Mauritius",
  "Mexico", "Morocco", "Nepal", "Netherlands", "New Zealand", "Nigeria", "Norway", "Oman",
  "Pakistan", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia",
  "Rwanda", "Saudi Arabia", "Singapore", "South Africa", "South Korea", "Spain", "Sri Lanka", "Sweden",
  "Switzerland", "Taiwan", "Tanzania", "Thailand", "Trinidad and Tobago", "Turkey", "Uganda", "Ukraine",
  "United Arab Emirates", "United Kingdom", "United States", "Venezuela", "Vietnam", "Zambia", "Zimbabwe",
];
